// ./src/app/shared/showcase/showcase-components.gen.ts
import { Type } from '@angular/core';
import { ActivityLogGridSampleComponent } from "../../../../src/app/shared/components/activity-log-grid/sample/activity-log-sample.component";
import { CaseSummaryBarSampleComponent } from "../../../../src/app/shared/components/case-summary-bar/case-summary-bar-sample/case-summary-bar-sample.component";
import { CheckboxColumnsSampleComponent } from "../../../../src/app/shared/components/checkbox-columns/checkbox-columns-sample.component";
import { DependentDropdownSampleComponent } from "../../../../src/app/shared/components/bits-dynamic-form/Samples/dependent-dropdowns/dependent-dropdown-sample.component";
import { DynamicFormDraftSampleComponent } from "../../../../src/app/shared/components/bits-dynamic-form/Samples/draft-sample/dynamic-form-draft-sample.component";
import { EzFormDialogSampleComponent } from "../../../../src/app/shared/showcase/samples/ez-form-dialog-sample/ez-form-dialog-sample.component";
import { DynamicFormSampleComponent } from "../../../../src/app/shared/showcase/samples/ez-form-sample-simple/dynamic-form-sample.component";
import { EzGridCustomPaginatorSampleComponent } from "../../../../src/app/shared/showcase/samples/ez-grid-custom-paginator-sample/ez-grid-custom-paginator-sample.component";
import { EzGridSampleComponent } from "../../../../src/app/shared/showcase/samples/ez-grid-users-sample/ez-grid.sample";


  /*
    Generated: Tue Nov 03 2026 20:19:43 GMT+0000 (Coordinated Universal Time)

    This file is generated at the same time the showcase documents are generated.
    If you change this file, it will get overridden when the docs are regenerated.

    This maps the string name of a sample component to an imported reference for use
    by the showcase.

    NOTE: This filename ends with .gen.ts which is used to exclude it from triggering another
    code generation when it changes.
  */

  export const APP_SHOWCASE_SAMPLE_COMPONENTS_MAP = new Map<string, Type<unknown>>([
    ["ActivityLogGridSampleComponent", ActivityLogGridSampleComponent],
    ["CaseSummaryBarSampleComponent", CaseSummaryBarSampleComponent],
    ["CheckboxColumnsSampleComponent", CheckboxColumnsSampleComponent],
    ["DependentDropdownSampleComponent", DependentDropdownSampleComponent],
    ["DynamicFormDraftSampleComponent", DynamicFormDraftSampleComponent],
    ["EzFormDialogSampleComponent", EzFormDialogSampleComponent],
    ["DynamicFormSampleComponent", DynamicFormSampleComponent],
    ["EzGridCustomPaginatorSampleComponent", EzGridCustomPaginatorSampleComponent],
    ["EzGridSampleComponent", EzGridSampleComponent],
  ]);
